import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export const ModalController = class ModalController extends Controller {
  static targets = ['container', 'wrapper', 'title', 'body', 'form']

  static OG_TEXT = 'data-og-text'
  static OG_PROP = 'data-og-prop'

  connect() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useClickOutside(this, { element: this.containerTarget })

    if (this.hasTitleTarget) this.titleTarget.setAttribute(this.OG_TEXT, this.titleTarget.innerText)
    if (this.hasBodyTarget) this.bodyTarget.setAttribute(this.OG_TEXT, this.bodyTarget.innerText)
    if (this.hasFormTarget && !!this.formTarget.getAttribute('data-src'))
      this.formTarget.setAttribute(this.OG_PROP + '-data-src', this.formTarget.getAttribute('data-src'))
  }

  show() {
    if (!this.hasWrapperTarget) return

    this.wrapperTarget.style.display = 'flex'
    document.getElementsByTagName('html')[0].style.overflow = 'hidden'
  }

  clickOutside(evt) {
    evt.stopPropagation()
    evt.preventDefault()
    this.hide()
  }

  hide() {
    if (!this.hasWrapperTarget) return

    this.wrapperTarget.style.display = 'none'
    document.getElementsByTagName('html')[0].style.overflow = 'scroll'
  }

  clickout() {
    if (this.clickoutLink && this.clickoutLink.click) {
      this.clickoutLink.click()
    }
  }

  bindText(target, text) {
    if (text) target.innerText = text
    else target.innerText = target.getAttribute(this.OG_TEXT)
  }

  bindProp(target, prop, propVal) {
    if (propVal) target.setAttribute(prop, propVal)
    else target.setAttribute(prop, target.getAttribute(this.OG_PROP + '-' + prop))
  }

  bind({ title, body, source, sourceId, clickoutLink }) {
    if (this.hasTitleTarget) this.bindText(this.titleTarget, title)
    if (this.hasBodyTarget) this.bindText(this.bodyTarget, body)

    if (this.hasFormTarget) {
      this.bindProp(this.formTarget, 'data-src', source)
      this.bindProp(this.formTarget, 'data-src-id', sourceId)
    }

    if (clickoutLink) this.clickoutLink = clickoutLink
  }
}

export const ModalTriggerController = class ModalTriggerController extends Controller {
  static outlets = ['modal']

  identity() {} // Stub function to allow stop propagation

  open(event) {
    if (!this.hasModalOutlet) return

    const clickoutLink = event.params.clickout ? event.currentTarget.querySelector('a') : undefined

    this.modalOutlet.bind({ ...event.params, clickoutLink })
    this.modalOutlet.show()
  }
}
